import React from 'react'
import styles from './index.module.css'

type Props = {
  index?: number
}

/**
 * A component that displays an index number for pane items
 * @param index - The index number to display, only renders if defined
 * @returns Div element containing the index number or empty if index is undefined
 */
const PaneItemIndex = ({ index }: Props): React.ReactElement<'div'> => {
  return (
    <div className={styles.paneItemIndex}>{index !== undefined && index}</div>
  )
}

export default PaneItemIndex
